<template>
  <v-container>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-container>
</template>
